import React from "react";
import { GenericPage } from "../../../../../pages";

import { systemRoutes } from "./configuration-system.route";
import { userRoute } from "./configuration-user.route";


export const configurationRoutes = [
  {
    path: "users",
    element: <GenericPage />,
    children: userRoute,
  },
  {
    path: "system",
    element: <GenericPage />,
    children: systemRoutes,
  },
];
